// form fixes
const observer = new MutationObserver(() => {
    const label = document.querySelector('form.g-container label[tabindex="0"]');
    if (label) {
        label.removeAttribute('tabindex');
    }

    const removeBtn = document.querySelector('div[data-file-remove]');
    if (removeBtn) {
        removeBtn.setAttribute('tabindex', '0');
        removeBtn.setAttribute('role', 'button'); // for screen readers

        // Allow Enter/Space to activate it
        removeBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                removeBtn.click();   // simulate click, triggers plugin removal
                document.querySelector('.gfb__dropzone--placeholder--button').focus();
            }
        });            
    }
});
observer.observe(document.body, { childList: true, subtree: true });

// mp4 playback toggle buttons — supports multiple instances per page
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('div.video-playback-toggle').forEach(function(toggle) {
        var btn = toggle.querySelector('button');
        var video = toggle.nextElementSibling;
        if (!btn || !video || video.tagName !== 'VIDEO') return;
        btn.addEventListener('click', function() {
            if (video.paused) {
                video.play();
                btn.className = 'video-playback-toggle--pause';
                btn.setAttribute('aria-label', 'Pause video');
            } else {
                video.pause();
                btn.className = 'video-playback-toggle--play';
                btn.setAttribute('aria-label', 'Play video');
            }
            video.controls = false;
        });
    });
});

// Cart remove buttons (high-31): handle navigation for button[data-url] in .cart__remove
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.cart__remove button[data-url]');
  if (!btn) return;
  window.location.href = btn.dataset.url;
});

// Product grid image keyboard navigation
// Enter/Space toggle between primary/secondary images; focus never auto-swaps the image.
// The mask's accessible name (aria-label) tracks the alt text of whichever image is shown.
(function() {
    function imageFor(mask, showSecondary) {
        if (showSecondary) {
            return mask.querySelector('.grid-product__secondary-image img');
        }
        var secondaryContainer = mask.querySelector('.grid-product__secondary-image');
        return Array.prototype.find.call(
            mask.querySelectorAll('img'),
            function(el) { return !secondaryContainer || !secondaryContainer.contains(el); }
        );
    }

    function altFor(mask, showSecondary) {
        var img = imageFor(mask, showSecondary);
        // Fall back to the primary image's alt so the button is never left nameless.
        if (!img || !img.alt) {
            var primary = imageFor(mask, false);
            return (primary && primary.alt) ? primary.alt : '';
        }
        return img.alt;
    }

    document.addEventListener('keydown', function(e) {
        var isActivate = e.key === 'Enter' || e.key === ' ';
        if (!isActivate) return;
        if (!e.target.matches('.grid-product__image-mask[tabindex]')) return;
        if (!e.target.querySelector('.grid-product__secondary-image')) return;
        e.preventDefault();
        var showSecondary = !e.target.classList.contains('pbk-image-active');
        e.target.classList.toggle('pbk-image-active', showSecondary);
        e.target.setAttribute('aria-pressed', showSecondary ? 'true' : 'false');
        // Updating the label on the focused button makes the screen reader
        // re-announce it (state + new name), so no separate live region is needed.
        e.target.setAttribute('aria-label', altFor(e.target, showSecondary));
    });

    document.addEventListener('focusout', function(e) {
        if (!e.target.matches('.grid-product__image-mask[tabindex]')) return;
        e.target.classList.remove('pbk-image-active');
        e.target.setAttribute('aria-pressed', 'false');
        // Restore the accessible name to the primary image once the user leaves.
        e.target.setAttribute('aria-label', altFor(e.target, false));
    });
}());

// Reviews.io rating snippet accessible name (high-89)
// ruk_rating_snippet is populated by Reviews.io JS after page load. The raw
// text uses star glyphs and "|" that screen readers don't handle well, so we
// wait for the widget to render and set a clean aria-label on the inner anchor.
(function() {
  'use strict';
  var container = document.querySelector('.ruk_rating_snippet');
  if (!container) return;

  var observer = new MutationObserver(function() {
    var link = container.querySelector('a, button');
    if (!link) return;
    if (link.getAttribute('aria-label')) { observer.disconnect(); return; }
    var text = (container.textContent || '').trim();
    var match = text.match(/(\d[\d.]*)[^\d]*(\d+)\s*[Rr]eview/);
    if (!match) return; // text not ready yet, wait for next mutation
    observer.disconnect();
    link.setAttribute('aria-label', match[1] + ' out of 5 stars, ' + match[2] + ' reviews');
  });

  observer.observe(container, { childList: true, subtree: true });
}());

// Reviews.io rating snippet popup dialog
// Clicking .ruk_rating_snippet opens a Reviews.io popup (#reviews_fade >
// #reviews_container) injected at the end of <body>. The widget wires the
// trigger and close element with onclick only — no keyboard activation, no
// dialog semantics, no focus management. All of that is layered on here.
(function() {
  'use strict';
  if (!document.querySelector('.ruk_rating_snippet')) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;

  // Record which snippet opened the popup (capture phase, so it runs before
  // the widget's own onclick) — focus returns here when the dialog closes.
  document.addEventListener('click', function(e) {
    var snippet = e.target.closest && e.target.closest('.ruk_rating_snippet[data-done]');
    if (snippet) lastTrigger = snippet;
  }, true);

  // The widget renders the snippet as role="button" but never listens for
  // keys, so activate it on both Enter and Space.
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var snippet = e.target.closest && e.target.closest('.ruk_rating_snippet[data-done]');
    if (!snippet) return;
    e.preventDefault();
    snippet.click();
  });

  function dialogIsOpen() {
    var fade = document.getElementById('reviews_fade');
    return !!fade && fade.style.display !== 'none';
  }

  function onOpen(container) {
    container.focus();
  }

  function onClose() {
    if (lastTrigger) lastTrigger.focus();
  }

  function setupDialog(fade) {
    var container = fade.querySelector('#reviews_container');
    var closeBtn = fade.querySelector('#reviews_container-close');
    if (!container) return;

    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-modal', 'true');
    container.setAttribute('aria-label', 'Product reviews');
    container.setAttribute('tabindex', '-1');

    // The close element is a plain <div class="close">×</div>.
    if (closeBtn) {
      closeBtn.setAttribute('role', 'button');
      closeBtn.setAttribute('tabindex', '0');
      closeBtn.setAttribute('aria-label', 'Close reviews dialog');
      closeBtn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          closeBtn.click();
        }
      });
    }

    // The widget opens/closes the popup by toggling inline display on the
    // overlay, so watch its style attribute to know when to move focus.
    var wasOpen = dialogIsOpen();
    new MutationObserver(function() {
      var open = dialogIsOpen();
      if (open && !wasOpen) onOpen(container);
      if (!open && wasOpen) onClose();
      wasOpen = open;
    }).observe(fade, { attributes: true, attributeFilter: ['style'] });
  }

  // Trap focus inside the dialog while it is open; Esc dismisses it.
  document.addEventListener('keydown', function(e) {
    if (!dialogIsOpen()) return;
    var container = document.getElementById('reviews_container');
    if (!container) return;

    if (e.key === 'Escape') {
      var closeBtn = document.getElementById('reviews_container-close');
      if (closeBtn) closeBtn.click();
      return;
    }

    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(
      container.querySelectorAll(FOCUSABLE),
      function(el) { return el.offsetParent !== null; }
    );
    if (!focusable.length) {
      e.preventDefault();
      container.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === container)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    } else if (!container.contains(active)) {
      e.preventDefault();
      first.focus();
    }
  });

  // #reviews_fade doesn't exist until the Reviews.io snippet script runs.
  var existing = document.getElementById('reviews_fade');
  if (existing) {
    setupDialog(existing);
  } else {
    var fadeObserver = new MutationObserver(function() {
      var fade = document.getElementById('reviews_fade');
      if (!fade) return;
      fadeObserver.disconnect();
      setupDialog(fade);
    });
    fadeObserver.observe(document.body, { childList: true, subtree: true });
  }
}());

// Formstack required-fields note
// The form embed is injected by Formstack after page load, so wait for a
// form whose id contains "fsForm", drop the note in after its first section
// header, then stop watching — the note is only ever added once.
(function() {
  'use strict';
  var NOTE_TEXT = 'Fields marked with an asterisk (*) are required';

  function insertNote() {
    var form = document.querySelector('form[id*="fsForm"]');
    if (!form) return false;
    var header = form.querySelector('div[class*="StyledSectionHeader"]');
    if (!header) return false;
    var note = document.createElement('span');
    note.className = 'fsNote';
    note.textContent = NOTE_TEXT;
    header.insertAdjacentElement('afterend', note);
    return true;
  }

  if (insertNote()) return;

  var observer = new MutationObserver(function() {
    if (insertNote()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}());

// Formstack name-field autocomplete
// Formstack renders first/last name as plain short-answer fields with no
// autocomplete hint, so the browser can't offer the user's own name and AT
// can't identify the field's purpose. The embed arrives after this script
// runs — and multi-page forms add fields later — so keep watching the DOM
// and stamp each input once.
(function() {
  'use strict';
  var RULES = [
    { test: /^first\s*name\b/, value: 'given-name' },
    { test: /^last\s*name\b/, value: 'family-name' }
  ];
  var FLAG = 'data-pbk-autocomplete'; // marks an input already examined

  // input.labels covers both wrapping labels and for=/id= pairs; the container
  // query is the fallback for markup where neither association is set.
  function labelTextFor(field, input) {
    var label = (input.labels && input.labels[0]) || field.querySelector('label');
    if (!label) return '';
    // Labels carry a required asterisk and can wrap across lines.
    return label.textContent.replace(/\*/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function applyAutocomplete() {
    var fields = document.querySelectorAll('.fsFieldShortAnswer');
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      // The class sits on the field wrapper in some form versions and on the
      // input itself in others.
      var input = field.matches('input') ? field : field.querySelector('input');
      if (!input || input.hasAttribute(FLAG)) continue;
      var text = labelTextFor(field, input);
      if (!text) continue; // label not rendered yet — retry on the next mutation
      input.setAttribute(FLAG, '');
      for (var j = 0; j < RULES.length; j++) {
        if (RULES[j].test.test(text)) {
          input.setAttribute('autocomplete', RULES[j].value);
          break;
        }
      }
    }
  }

  // Mutations arrive in bursts while the embed builds itself, so coalesce them
  // into a single pass.
  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(applyAutocomplete, 50);
  }

  applyAutocomplete();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
}());

// a11y debug, highlight currently tabbed element
// (function () {
//     let last;

//     document.addEventListener("focusin", e => {
//         // Remove outline from previously focused element
//         if (last) last.style.outline = "";

//         // Add outline to new focused element
//         e.target.style.outline = "3px solid red";
//         last = e.target;
//     });
// })();
